module.exports = __webpack_public_path__ + "static/media/nydi-placeholder.78792403.jpg";